import { useState, useEffect } from 'react';

export const useFetch = ({ action, variables = null, autoFetch = true }) => {
  const [ data, setData ] = useState();
  const [ error, setErrors ] = useState();
  const [ loading, setLoading ] = useState(false);

  useEffect(() => {
    let isActive = true;
    if (autoFetch) {
      setLoading(true)

      action(variables)
      .then(res => {
        if (isActive){
        setData(res)
        setLoading(false)}
      })
      .catch(err => {
        if(isActive){
        setErrors(err)
        setLoading(false)}
      })
    }
    return () => {
      isActive = false;
    };
  }, []);

  const refetch = () => {
    setLoading(true)
    action(variables).then((res) => {
      setData(res)
      setLoading(false)
    })
    .catch(err => {
      setErrors(err)
      setLoading(false)
    })
  };

  const result = { data, error, loading, refetch };
  return result;
}
